import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysRemindSolveMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();
  const { fromUserName } = raw;

  if (fromUserName) {
    return (
      <SystemMessage>
        {t('scene.chatWorkspace.messageThread.systemMessage.buyerIssueResolved', {
          buyerNick: fromUserName,
        })}
      </SystemMessage>
    );
  }

  return null;
});
